import { Component, Input } from '@angular/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  AggFunc,
  BaseComponent,
  GridService,
  ProductStockAllocations,
  SalesOrderStockAllocationService,
  StockItemAllocation,
  StockItemService,
  SummaryItem,
} from 'tms-lib';

@Component({
  selector: 'app-product-stock-allocations',
  templateUrl: './product-stock-allocations.component.html',
  styleUrl: './product-stock-allocations.component.scss',
})
export class ProductStockAllocationsComponent extends BaseComponent {
  @Input() model: ProductStockAllocations;
  @Input() showDelete = false;

  constructor(
    private gridService: GridService,
    private salesOrderStockAllocationService: SalesOrderStockAllocationService,
    private stockItemService: StockItemService,
  ) {
    super();
  }

  summaryItems(model: ProductStockAllocations): SummaryItem[] {
    return [
      { label: $localize`Product`, value: model.productKey },
      { label: $localize`Description`, value: model.productDescription },
      { label: $localize`Product Type`, value: model.productType },
    ];
  }

  readonly columnDefs: ColDef[] = [
    this.gridService.text('allocationType', $localize`Allocation Type`),
    this.gridService.text('stockNo', $localize`Stock Number`),
    this.gridService.text('orderNo', $localize`Order Number`),
    this.gridService.text('customerKey', $localize`Customer Key`),
    this.gridService.text('customerName', $localize`Customer Name`),
    this.gridService.numberFormat('allocated', $localize`Allocated`, { aggFunc: AggFunc.sum }),
    this.gridService.date('deliveryDate', $localize`Delivery Date`),
  ];

  get rowData$(): Observable<StockItemAllocation[]> {
    return of(this.model?.allocations ?? []);
  }

  getModel() {
    this.stockItemService
      .productStockAllocations(this.model.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe((model: ProductStockAllocations) => (this.model = model));
  }

  delete(stockItemAllocation: StockItemAllocation) {
    this.salesOrderStockAllocationService
      .delete(stockItemAllocation.stockItemId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.getModel());
  }
}
